<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-flex md12>
              <DataTableMain :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"/>
            </v-flex>
        </v-layout>
        <MainFormDialog v-if="get_dialogMain.dialog" :model="objectMain" :params="paramsDialog" />
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialog/main/MainFormDialog'
import { UserSession } from '@/store/modules/config'
import { Permission } from '@/mixins/permissionMain'
import * as XLSX from 'xlsx'
export default {
  mixins: [Permission],
  data: () => ({
    dialogImport: false, // Controla el diálogo
    file: null, // Archivo seleccionado
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'empresa.empleados.create' },
          { title: 'Importar', icon: 'mdi-upload', color: 'info', action: 'importData', code: 'empresa.empleados.import' },
          { title: 'Excel', icon: 'mdi-file-excel', color: 'success', action: 'ExcelData', code: 'empresa.empleados.excel' },
          { title: 'Excel de datos', icon: 'mdi-file-excel', color: 'success', action: 'ExcelDatos', code: '' }
        ],
        titles: [
          { text: 'Empleado', value: 'NombreCompleto', class: 'black--text' },
          // { text: 'Rol', value: 'rol.nombre', class: 'black--text' },
          // { text: 'UuAa', value: 'uu_aa.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          // { text: 'Fecha Creacion', value: 'Created', class: 'black--text' },
          // { text: 'Fecha Actualizada', value: 'Updated', class: 'black--text' },
          { text: '', value: 'ActionsGral', class: 'black--text', align: 'right' }
        ],
        filter: true,
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Activar / Desactivar', icon: 'mdi-checkbox-blank-circle', color: 'grey darken-3', action: 'disableData', code: 'empresa.empleados.up-down' },
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-3', action: 'updateData', code: 'empresa.empleados.create' },
          { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-3', action: 'deleteData', code: 'empresa.empleados.delete' }
        ]
      },
      footer: {
        paging: true
      }
    },
    empleado: {},
    objectMain: {},
    paramsDialog: {}
  }),
  components: {
    DataTableMain,
    MainFormDialog
  },
  mounted () {
    this.user = UserSession()
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects', 'PUTDisableEnableObjectService', 'DELETEObjectService', 'importEmpleados']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_OBJECTS', 'SET_DATA_SECOUND_MAIN', 'SHOW_DIALOG_ALERT_MAIN']),
    SuccessTableAction (item) {
      this[item.action](item)
    },
    /* *==========*==========*==========*==========*==========*==========*==========*==========* */
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('empresa.empleados.show')
    },
    importData () {
      const data = {
        empleado_id: this.user.empleado_id
      }
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        form: 'process',
        with: '50%',
        title: 'Importar Integrantes',
        body: {
          objectMain: { data },
          paramsDialog: {
            url: this.get_urls['empresa.empleados.execute'],
            urloption: this.get_urls['empresa.empleados.options'],
            message: 'Registro Agregado Correctamente',
            formdata: true,
            updated: true,
            returnObject: true,
            setmodel: true
            // onSuccess: () => {
            //   this.refreshData() // Refrescar tabla después de la importación
            // }
          },
          method: 'form-data'
        }
      })
    },
    ExcelData () {
      // Definir los encabezados personalizados
      const headers = [
        'nombres',
        'apellidos',
        'telefono',
        'rfc',
        'fecha_nacimiento',
        'curp',
        'calle',
        'numero',
        'cruzamiento 1',
        'cruzamiento 2',
        'codigo postal'
      ]

      // Crear una hoja de cálculo con los encabezados y sin datos
      const ws = XLSX.utils.aoa_to_sheet([headers])

      // Crear un nuevo libro de Excel y agregar la hoja
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Integrantes')

      // Generar y descargar el archivo Excel
      XLSX.writeFile(wb, 'Integrantes.xlsx')
    },
    ExcelDatos () {
      const headers = [
        'nombres',
        'apellidos',
        'telefono',
        'rfc',
        'fecha_nacimiento',
        'curp',
        'calle',
        'numero',
        'cruzamiento 1',
        'cruzamiento 2',
        'codigo postal'
      ]

      // Procesamos los datos de empleados desde el store
      const data = this.table.body.data.map(emp => {
        const carac = emp.caracteristicas || {}
        const domicilio = carac.domicilio || {}

        return [
          emp.nombres || '',
          emp.apellidos || '',
          carac.telefono || '',
          carac.rfc || '',
          carac.fecha_nacimiento || '',
          carac.curp || '',
          domicilio.calle || '',
          domicilio.numero || '',
          domicilio.cruzamiento1 || '',
          domicilio.cruzamiento2 || '',
          domicilio.cp || ''
        ]
      })

      // Creamos hoja de cálculo con encabezados + datos
      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data])
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Empleados')

      // Descargamos el archivo
      XLSX.writeFile(workbook, 'Empleados.xlsx')
    },
    newData (item) {
      console.log('empleado', this.user.empleado_id)
      const data = {
        empleado_id: this.user.empleado_id,
        item: item
      }
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: 680,
        title: 'Nuevo Empleado',
        body: {
          objectMain: data,
          paramsDialog: {
            form: this.get_EmpleadoForm,
            url: this.get_urls['empresa.empleados.create'],
            message: 'Registro Agregado Correctamente',
            updated: true,
            returnObject: true,
            setmodel: true
          }
        }
      })
    },
    disableData  ({ item }) {
      const name = (item.activo === 'si') ? 'Desactivar' : 'Activar'
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'disable',
        with: '40%',
        title: `${name} Empleado`,
        body: {
          objectMain: item,
          url: this.get_urls['empresa.empleados.up-down'],
          message: `¿Estás seguro en ${name} el registro?`,
          description: ''
        },
        confirmButtonText: `Sí, ${name}`,
        cancelButtonText: 'No, Cancelar'
      })
    },
    updateData ({ item }) {
      // Log inicial para verificar el objeto entrante
      console.log('Objeto recibido para actualizar:', item)
      const data = {
        id: item.id,
        nombres: item?.nombres,
        apellidos: item?.apellidos,
        telefono: item.caracteristicas?.telefono,
        calle: item.caracteristicas?.domicilio?.calle,
        cp: item.caracteristicas?.domicilio?.cp,
        numero: item.caracteristicas?.domicilio?.numero,
        cruzamiento1: item.caracteristicas?.domicilio?.cruzamiento1,
        empleado_id: item?.folio,
        cruzamiento2: item.caracteristicas?.domicilio?.cruzamiento2,
        rfc: item.caracteristicas?.rfc,
        curp: item.caracteristicas?.curp,
        fecha_nacimiento: item.caracteristicas?.fecha_nacimiento
        // tipo_personal_id: item.tipo_personal_id, // Verifica el ID seleccionado
        // tipo_personal: {
        //   id: item.tipo_personal_id, // ID esperado por el backend
        //   nombre: item.rol?.nombre // Etiqueta visible
        // },
        // uuaa_id: item?.uuaa_id, // ID del UuAa seleccionado
        // uuaa: {
        //   id: item?.uuaa_id, // ID esperado por el backend
        //   nombre: item?.uu_aa?.nombre // Etiqueta visible
        // }
      }
      this.item = item
      this.SHOW_DIALOG_MAIN({
        type: 'update',
        with: 850,
        title: 'Editar Empleado',
        body: {
          objectMain: data,
          paramsDialog: {
            form: this.get_EmpleadoForm,
            url: this.get_urls['empresa.empleados.create'],
            message: 'Registro Actualizado Correctamente',
            setmodel: true
          }
        }
      })

      // Log después de abrir el diálogo
      console.log('Diálogo de edición mostrado con datos:', data)
    },
    deleteData  ({ item }) {
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'delete',
        with: '40%',
        title: 'Eliminar Empleado',
        body: {
          objectMain: item,
          url: this.get_urls['empresa.empleados.delete'],
          message: '¿Estás seguro de eliminar el registro?',
          description: 'No podras revertir el movimiento'
        },
        confirmButtonText: 'Sí, Eliminar',
        cancelButtonText: 'No, Cancelar'
      })
    },
    /* *==========*==========*==========*==========*==========*==========*==========*==========* */
    ExecuteUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.GETObjects({ url: router })
      } else {
        this.getUrlServices()
      }
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects', 'get_ImportForm',
      'get_EmpleadoForm'])
  },
  watch: {
    get_urls () { this.refreshData({}) },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }

}
</script>

<style>

</style>
